import { useEffect, useState } from "react";
import MapWrapper from "../InteractiveMap";
import { abujaLocations, lagosLocations } from "../../../constant/data";
import { Location } from "../../../type";

const LocationSection = () => {
  const [selectedCity, setSelectedCity] = useState<"LAGOS" | "ABUJA">("LAGOS");
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedLocation, setSelectedLocation] = useState<Location>({
    name: "Circle Mall",
    position: {
      lat: 6.4383,
      lng: 3.5087,
    },
    address: "Lekki Toll Road, Lekki Penninsula II, Lekki",
    mapsLink:
      "https://www.google.com/maps?q=Circle+Mall,+Lekki,+Lagos,+Nigeria",
  });
  const locations = selectedCity === "LAGOS" ? lagosLocations : abujaLocations;
  useEffect(() => {
    if (selectedCity === "LAGOS") {
      setSelectedLocation({
        name: "Circle Mall",
        position: {
          lat: 6.4383,
          lng: 3.5087,
        },
        address: "Lekki Toll Road, Lekki Penninsula II, Lekki",
        mapsLink:
          "https://www.google.com/maps?q=Circle+Mall,+Lekki,+Lagos,+Nigeria",
      });
    } else {
      setSelectedLocation({
        name: "Apo",
        position: {
          lat: 9.0146,
          lng: 7.4898,
        },
        address: "AP Filling Station Apo - Opp GTBank, Along GUDU ROAD, Abuja",
        mapsLink:
          "https://www.google.com/maps?q=AP+Filling+Station+Apo+-+Opp+GTBank,+Along+GUDU+ROAD,+Abuja,+Nigeria",
      });
    }
  }, [selectedCity]);
  return (
    <section
      id="location"
      className=" mt-16 px-4 sm:px-8 lg:px-20 rounded-br-lg rounded-bl-lg"
    >
      <div className="max-w-4xl mx-auto text-center mb-10">
        <h3 className="lg:text-3xl text-2xl text-[#0E1728] font-worksans mb-4">Find a Locker Near You</h3>
      </div>
      <div className="flex bmd:flex-row flex-col bmd:space-y-0 space-y-10 bmd:space-x-3">
        <div className="xl:w-[40%] bmd:w-[50%]">
          <div className="flex space-x-5 ">
            <p
              className={`font-worksans text-xl cursor-pointer ${
                selectedCity === "LAGOS"
                  ? "border-b-[2px] border-b-[#289D17]"
                  : ""
              }`}
              onClick={() => {
                setSelectedCity("LAGOS");
                setSelectedId(0);
              }}
            >
              LAGOS
            </p>
            <p
              className={`font-worksans text-xl cursor-pointer ${
                selectedCity === "ABUJA"
                  ? "border-b-[2px] border-b-[#289D17]"
                  : ""
              }`}
              onClick={() => {
                setSelectedCity("ABUJA");
                setSelectedId(0);
              }}
            >
              ABUJA
            </p>
          </div>
          <div className="h-[420px]  overflow-auto">
            {locations.map((loc, index) => (
              <div
                key={index}
                className="flex items-center space-x-3 mt-5 border-b pb-4"
                onClick={() => {
                  setSelectedLocation(loc.location);
                  setSelectedId(index);
                }}
              >
                <div
                  className={`h-6 w-6 cursor-pointer shrink-0 flex justify-center items-center border ${
                    selectedId === index
                      ? "border-[#289D17]"
                      : "border-[#E6E8E6]"
                  }  rounded-full`}
                >
                  <div
                    className={`h-3 w-3 ${
                      selectedId === index && "bg-[#289D17]"
                    }  rounded-full`}
                  ></div>
                </div>
                <div>
                  <p className="text-lg font-onestMedium text-[#0E1728]">
                    {loc.area}
                  </p>
                  <p className="text-base text-[#464748] font-onestRegular">
                    {loc.address}
                  </p>
                </div>
              </div>
            ))}
          </div>
          {/* <div className="flex items-center space-x-3 mt-5 border-b pb-2">
            <div className="h-6 w-6 cursor-pointer shrink-0 flex justify-center items-center border border-[#289D17] rounded-full">
              <div className="h-3 w-3 bg-[#289D17] rounded-full"></div>
            </div>
            <div>
              <p className="text-lg  font-onestMedium text-[#0E1728]">
                Osapa/Jakande
              </p>
              <p className="text-base text-[#464748] font-onestRegular">
                Circle Mall - Shoprite Osapa, Jakande bus stop Lekki, Lagos
              </p>
            </div>
          </div> */}
        </div>
        <MapWrapper location={selectedLocation} />
      </div>
    </section>
  );
};

export default LocationSection;
